import React from 'react';
import Loading from "../../Loading";
import {Link} from "react-router-dom";
import {PlusIcon} from "../../../icons/icons";

const CustomLink = ({title , link , loading , typeTwo , styles , icon}) => {

  return (
    <Link
      to={link}
      className={`tracking-wide text-center max-h-[48px] font-semibold  ${typeTwo ? "bg-transparent  text-main border border-main" : "bg-main  text-white"}  gray-100 w-full py-4 px-10 rounded-md  transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none ${ styles }`}>
      {icon &&
        icon
      }
      <span>
          {loading ? <Loading/> : title}
      </span>
    </Link>
  );
};

export default CustomLink;
